import { type LabeledOption } from './enum-labels'

export function AvailableCard({
  option,
  onClick
}: {
  option: LabeledOption
  onClick: () => void
}) {
  return (
    <li>
      <button
        type='button'
        onClick={onClick}
        className='group flex w-full cursor-pointer items-start gap-3 rounded-xl border border-border bg-page p-4 text-left transition-all hover:border-accent/40 hover:bg-cream/40'
      >
        <span
          aria-hidden
          className='mt-0.5 grid size-5 shrink-0 place-items-center rounded-md border border-border bg-page text-ink-muted transition-colors group-hover:border-accent group-hover:bg-accent group-hover:text-white'
        >
          <svg viewBox='0 0 12 12' className='size-3'>
            <path
              fill='none'
              stroke='currentColor'
              strokeWidth='2'
              strokeLinecap='round'
              d='M6 2v8M2 6h8'
            />
          </svg>
        </span>
        <span className='min-w-0 flex-1'>
          <span className='block text-[14px] font-medium text-ink'>
            {option.label}
          </span>
          <span className='mt-0.5 block text-[12px] text-ink-soft'>
            {option.description}
          </span>
        </span>
      </button>
    </li>
  )
}
